import './App.css';
import LocationTracker from './components/LocationTracker';
function App() {
  return (
    <div className="App">
      <header className="App-header">
        <LocationTracker />
      </header>
    </div>
  );
}

export default App;
